export const canUseHtmlPopoverApi = typeof document.createElement("div").showPopover === "function";
